import { render } from "./RegionKostanay.vue?vue&type=template&id=a779470e&ts=true"
import script from "./RegionKostanay.vue?vue&type=script&lang=ts"
export * from "./RegionKostanay.vue?vue&type=script&lang=ts"

import "./RegionKostanay.vue?vue&type=style&index=0&id=a779470e&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__